import * as Yup from 'yup';
import { AnnouncementAudienceType } from '@/app/enums/AnnouncementAudienceType';
import {
  type AnnouncementFormValues,
  type AnnouncementValidityFormValues,
} from '@/app/pages/notifications/announcements/core/_models';
import { hasAnnouncementBodyContent } from '@/app/pages/notifications/announcements/core/_utils';

const END_AFTER_START_MESSAGE = 'O fim precisa ser depois do início';

export const announcementFormSchema = Yup.object().shape({
  title: Yup.string().trim().required('Informe o título').max(255, 'Máximo 255 caracteres'),
  body: Yup.string().test('has-content', 'Escreva o texto ou adicione uma imagem ou vídeo ao comunicado', (body = '') =>
    hasAnnouncementBodyContent(body),
  ),
  userRoleIds: Yup.array().when('audienceType', {
    is: AnnouncementAudienceType.ROLES,
    then: (schema) => schema.min(1, 'Escolha ao menos um perfil'),
  }),
  userIds: Yup.array().when('audienceType', {
    is: AnnouncementAudienceType.USERS,
    then: (schema) => schema.min(1, 'Escolha ao menos um usuário'),
  }),
  startDate: Yup.string().when('startsNow', {
    is: false,
    then: (schema) => schema.required('Informe o início'),
  }),
  endDate: Yup.string().test('after-start', END_AFTER_START_MESSAGE, (endDate, context) => {
    if (!endDate) return true;
    const { startsNow, startDate } = context.parent as AnnouncementFormValues;
    // O início vazio já tem erro próprio (acima); não duplicar aqui com um "Invalid Date".
    if (!startsNow && !startDate) return true;
    const start = startsNow ? new Date() : new Date(startDate);
    return new Date(endDate) > start;
  }),
});

export const announcementValiditySchema = Yup.object().shape({
  startDate: Yup.string().required('Informe o início'),
  endDate: Yup.string().test('after-start', END_AFTER_START_MESSAGE, (endDate, context) => {
    if (!endDate) return true;
    const { startDate } = context.parent as AnnouncementValidityFormValues;
    return new Date(endDate) > new Date(startDate);
  }),
});
